import App from './App.svelte';
import './lib/logger';
const app = new App({
    target: document.body,
    props: {},
});
export default app;
